import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/debounceTime'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/switchMap'
import * as App from '../../app'
import * as Menu from '../../components/menu'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'

const initialLoadUserSettings = (
    action$: ReduxObservable.ActionsObservable<Redux.Action>,
    store: Redux.Store<ApplicationState>,
    { history }: App.Dependencies,
  ) => action$.ofType(App.SELECT_COMMUNITY, Router.ON_ENTER)
    .filter(() => history.location.pathname.startsWith(Menu.USER_SETTINGS_URL))
    .map(() => Actions.fetchUserSettings(store.getState().app.selectedCommunity))

const onUseKeyUpdate = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Request.successConstant(Constants.ADD_USER_KEY))
  .map(() => Actions.fetchUserSettings(store.getState().app.selectedCommunity))

export const epic = ReduxObservable.combineEpics(
  initialLoadUserSettings,
  onUseKeyUpdate,
)



// WEBPACK FOOTER //
// ./src/pages/user-settings/epic.ts